import { render, staticRenderFns } from "./AggregateElementContentsItem.vue?vue&type=template&id=4b17cf88&scoped=true"
import script from "./AggregateElementContentsItem.vue?vue&type=script&lang=js"
export * from "./AggregateElementContentsItem.vue?vue&type=script&lang=js"
import style0 from "./AggregateElementContentsItem.vue?vue&type=style&index=0&id=4b17cf88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b17cf88",
  null
  
)

export default component.exports